import { render, staticRenderFns } from "./CorporateCollaboration.vue?vue&type=template&id=0cd1f18c"
import script from "./CorporateCollaboration.vue?vue&type=script&lang=js"
export * from "./CorporateCollaboration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports